import { Component, ChangeDetectionStrategy, output, input, signal, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { IconComponent } from '../shared/icon/icon.component';
import { SidebarService } from '../../services/sidebar.service'
import { catchError, filter, of, timeout } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MasterService } from '@/src/services/master.service';
import { AuthenticationService } from '@/src/services/authentication.service';
import { SHOW_ERROR } from '../../helpers/http-context.tokens';
import { M_STORE } from '@/src/models/M_STORE';
import { WebSocketService } from '@/src/services/webSocket.service';

interface MenuItem {
  id: string;
  label: string;
  iconName: string;
  route?: string;
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [TranslateModule, IconComponent],
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-full block'
  }
})
export class SidebarComponent {
  private masterService = inject(MasterService)
  today: any;
  userName: any;
  isCollapsed = input.required<boolean>();
  isMobileOpen = input.required<boolean>();

  logout = output<void>();
  closeMobileMenu = output<void>();
  toggleCollapse = output<void>();

  colorVan = signal<string>('red');
  currentUrl = signal('');

  // FIX: Explicitly typed `router` with `Router` to fix type inference issue where it was resolved as `unknown`.
  private router: Router = inject(Router);
  private sidebarService = inject(SidebarService)
  private webSocket = inject(WebSocketService)

  menuItems = signal<MenuItem[]>([
    { id: 'dashboard', label: 'SYSMENUS0006', iconName: 'layout-dashboard', route: '/dashboard' },
    { id: 'pos', label: 'SYSMENUS0014', iconName: 'shopping-cart', route: '/pos' },
    { id: 'reservation', label: 'SYSMENUS0009', iconName: 'calendar', route: '/reservation' },
    { id: 'sales_inquiry', label: 'SYSMENUS0010', iconName: 'file-text', route: '/sales-inquiry' },
    { id: 'membership', label: 'SYSMENUS0008', iconName: 'users', route: '/membership' },
    // { id: 'cancellation', label: 'sidebar.cancellation', iconName: 'x-circle', route: '/cancellation' },
    { id: 'service_env', label: 'SYSMENUS0012', iconName: 'layers', route: '/settings/service' },
    // { id: 'attendance', label: 'sidebar.attendance', iconName: 'clock' }, // No route yet
    { id: 'settings', label: 'SYSMENUS0011', iconName: 'settings', route: '/settings/store/env' },
    // { id: 'language', label: 'sidebar.languageSettings', iconName: 'globe', route: '/settings/language' },
  ]);

  constructor(private http: HttpClient, private translate: TranslateService, private auth: AuthenticationService) {
    setInterval(() => {
      this.checkVanConnecting();
    }, 60000); // Check every 60 seconds
    this.checkVanConnecting();

    this.today = this.masterService.formatDateYYYYMMDD3(new Date())
    this.userName = auth.getUserNm();
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.currentUrl.set(e.urlAfterRedirects);
      });

    this.sidebarService.menuActive$.subscribe(res => {
      if (res) {
        this.currentUrl.set(res);
      }
    });

    this.webSocket.status$.subscribe(status => {
      if (status) {
        this.colorVan.set('green');
      } else {
        this.colorVan.set('red');
      }
    });
  }

  onLogout() {
    this.masterService.hideCartTemp();
    this.logout.emit();
  }

  onNavigate(route?: string) {
    if (route) {
      this.router.navigateByUrl(route);
      if (this.isMobileOpen()) {
        this.closeMobileMenu.emit();
      }
    }
  }

  onNavigateToProfile() {
    this.router.navigateByUrl('/profile');
    if (this.isMobileOpen()) {
      this.closeMobileMenu.emit();
    }
  }

  isActive(route?: string): boolean {
    const url = this.currentUrl();
    if (!route || !url) return false;

    // if (route === '/dashboard') {
    //   return url === '/dashboard';
    // }

    const baseRoute = route.split('/').slice(0, 3).join('/');

    return url.startsWith(baseRoute);
  }

  onToggleCollapse() {
    this.toggleCollapse.emit();
  }

  // checkVanConnecting() {
  //   this.http.post(
  //     'http://127.0.0.1:51234/api/Printer/test',
  //     {},
  //     {
  //       context: new HttpContext().set(SHOW_ERROR, false)
  //     }
  //   )
  //     .pipe(
  //       timeout(3000),
  //       catchError(err => {
  //         console.log('Printer error:', err);

  //         this.colorVan.set('red');
  //         return of(null);
  //       })
  //     )
  //     .subscribe((res: any) => {
  //       if (res?.success) {
  //         this.colorVan.set('green');
  //       } else {
  //         this.colorVan.set('red');
  //       }
  //     });
  // }

  checkVanConnecting() {
    // try {
    //   const param = {
    //     P_HQ_CD: this.auth.getHQCD(),
    //     P_STR_CD: this.auth.getStrCd()
    //   }
    //   //SP_STR_GET_INFO
    //   this.masterService.excute_spNoLoading('6a839b98-298d-11f1-9014-00155d001e02', param).then(async (res: any) => {
    //     if (res?.isOK) {
    //       const store = new M_STORE().getStore(res?.result?.dataRes[0]?.rows[0])
    //       const controller = new AbortController();
    //       const timeoutId = setTimeout(() => controller.abort(), 3000);
    //       const PrinterConfig =
    //       {
    //         PortName: `COM${store?.comport}`,
    //         BaudRate: store?.bauD_RATE_NM,
    //         DataBits: 8,
    //         Parity: "None",
    //         StopBits: "One",
    //         Handshake: "None",
    //         ReadTimeout: 500,
    //         WriteTimeout: 500,
    //       }
    //       const result = await fetch('http://127.0.0.1:51234/api/Printer/test', {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(PrinterConfig),
    //         signal: controller.signal
    //       });

    //       clearTimeout(timeoutId);

    //       const data = await result.json();

    //       if (data?.success) {
    //         this.colorVan.set('green');
    //       } else {
    //         this.colorVan.set('red');
    //       }

    //     }
    //   })
    // }
    // catch (err: any) {
    //   console.log('Printer error:', err);

    //   // timeout sẽ vào đây
    //   this.colorVan.set('red');
    // }
  }
}
